import type { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';

import { AppServerResponse } from '../../utils/interfaces/generalInterfaces';
import { PaymentsInitialState } from '../globalSlices/paymentsSlice';
import {
  createPlaidPaymentMethod,
  getBuyerTransactions,
  createExternalPaymentMethod,
  createSupplierPaymentMethod,
  payInvoices,
  getSupplierTransactions,
  createSupplierPlaidPaymentMethod,
  getSupplierPaymentMethods,
  supplierWithdraw,
  getWeekPaymentTransactionsLimitationsForMainBuyer,
  getStripeSupplierAccount,
  getStripeConfig,
  getSupplierRegistrationStatus,
  dwollaTransactionLimitNotifyDill,
  getTransactionById,
  verifyDwollaMicroTransactions,
  getMainBuyerPaymentMethods,
  deletePaymentMethodByMainBuyer,
  getSupplierPaymentsFiles,
  getSupplierPaymentsReportJson,
  getBuyerTransactionsFiles,
  sendInvoicePaymentReminderEmail,
  sendBulkInvoicePaymentReminderEmails,
  getSupplierCustomerPaymentMethods,
  getSupplierPosTransactions,
  payFixedAmount,
  getPlaidBankStatementsPDF,
  getPlaidBankStatements,
  getScheduledPayments,
  getSupplierScheduledPayments,
  createScheduledPayment,
  updateScheduledPaymentDate,
  cancelScheduledPayment,
} from '../services/paymentsService';

export const createExternalPaymentMethodExtraReducer = (
  builder: ActionReducerMapBuilder<PaymentsInitialState>
) => {
  const reducerId = 'createExternalPaymentMethod';
  builder.addCase(createExternalPaymentMethod.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    createExternalPaymentMethod.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (action.payload && action.payload.success && action.payload?.data) {
      } else {
      }
    }
  );
  builder.addCase(createExternalPaymentMethod.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};
export const verifyDwollaMicroTransactionsExtraReducer = (
  builder: ActionReducerMapBuilder<PaymentsInitialState>
) => {
  const reducerId = 'verifyDwollaMicroTransactions';
  builder.addCase(verifyDwollaMicroTransactions.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    verifyDwollaMicroTransactions.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (action.payload && action.payload.success && action.payload?.data) {
      } else {
      }
    }
  );
  builder.addCase(verifyDwollaMicroTransactions.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const createPlaidPaymentMethodExtraReducer = (
  builder: ActionReducerMapBuilder<PaymentsInitialState>
) => {
  const reducerId = 'createPlaidPaymentMethod';
  builder.addCase(createPlaidPaymentMethod.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    createPlaidPaymentMethod.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (action.payload && action.payload.success && action.payload?.data) {
      } else {
      }
    }
  );
  builder.addCase(createPlaidPaymentMethod.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const createSupplierPlaidPaymentMethodExtraReducer = (
  builder: ActionReducerMapBuilder<PaymentsInitialState>
) => {
  const reducerId = 'createSupplierPlaidPaymentMethod';
  builder.addCase(createSupplierPlaidPaymentMethod.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    createSupplierPlaidPaymentMethod.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (action.payload && action.payload.success && action.payload?.data) {
      } else {
      }
    }
  );
  builder.addCase(
    createSupplierPlaidPaymentMethod.rejected,
    (state, action: PayloadAction<any>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    }
  );
};

export const createSupplierPaymentMethodExtraReducer = (
  builder: ActionReducerMapBuilder<PaymentsInitialState>
) => {
  const reducerId = 'createSupplierPaymentMethod';
  builder.addCase(createSupplierPaymentMethod.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    createSupplierPaymentMethod.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (action.payload && action.payload.success && action.payload?.data) {
      } else {
      }
    }
  );
  builder.addCase(createSupplierPaymentMethod.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const getMainBuyerPaymentMethodsExtraReducer = (
  builder: ActionReducerMapBuilder<PaymentsInitialState>
) => {
  const reducerId = 'getMainBuyerPaymentMethods';
  builder.addCase(getMainBuyerPaymentMethods.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    getMainBuyerPaymentMethods.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (action.payload && action.payload.success && action.payload?.data) {
        state.paymentMethods = action.payload?.data;
      }
    }
  );
  builder.addCase(getMainBuyerPaymentMethods.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const getSupplierPaymentMethodsExtraReducer = (
  builder: ActionReducerMapBuilder<PaymentsInitialState>
) => {
  const reducerId = 'getSupplierPaymentMethods';
  builder.addCase(getSupplierPaymentMethods.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    getSupplierPaymentMethods.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (action.payload && action.payload.success && action.payload?.data) {
        state.supplierPaymentMethods = action.payload?.data;
      }
    }
  );
  builder.addCase(getSupplierPaymentMethods.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const supplierWithdrawExtraReducer = (
  builder: ActionReducerMapBuilder<PaymentsInitialState>
) => {
  const reducerId = 'supplierWithdraw';
  builder.addCase(supplierWithdraw.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    supplierWithdraw.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (action.payload && action.payload.success && action.payload?.data) {
      }
    }
  );
  builder.addCase(supplierWithdraw.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const getBuyerTransactionsExtraReducer = (
  builder: ActionReducerMapBuilder<PaymentsInitialState>
) => {
  const reducerId = 'getBuyerTransactions';
  builder.addCase(getBuyerTransactions.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
    state.buyerTransactions = [];
  });
  builder.addCase(
    getBuyerTransactions.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);

      if (action.payload && action.payload.success && action.payload?.data) {
        state.buyerTransactions = action.payload?.data;
      }
    }
  );
  builder.addCase(getBuyerTransactions.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};
export const getBuyerTransactionsFilesExtraReducer = (
  builder: ActionReducerMapBuilder<PaymentsInitialState>
) => {
  const reducerId = 'getBuyerTransactionsFiles';
  builder.addCase(getBuyerTransactionsFiles.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    getBuyerTransactionsFiles.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      if (action.payload) {
        state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      }
    }
  );
  builder.addCase(getBuyerTransactionsFiles.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};
export const getTransactionByIdExtraReducer = (
  builder: ActionReducerMapBuilder<PaymentsInitialState>
) => {
  const reducerId = 'getTransactionById';
  builder.addCase(getTransactionById.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    getTransactionById.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    }
  );
  builder.addCase(getTransactionById.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};
export const payInvoicesExtraReducer = (builder: ActionReducerMapBuilder<PaymentsInitialState>) => {
  const reducerId = 'payInvoices';
  builder.addCase(payInvoices.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
    state.paymentError = null;
  });
  builder.addCase(
    payInvoices.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (action.payload && action.payload.success && action.payload?.data) {
        // state.transactions = action.payload?.data;
      }
    }
  );
  builder.addCase(payInvoices.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    state.paymentError = action.payload;
  });
};

export const dwollaTransactionLimitNotifyDillExtraReducer = (
  builder: ActionReducerMapBuilder<PaymentsInitialState>
) => {
  const reducerId = 'dwollaTransactionLimitNotifyDill';
  builder.addCase(dwollaTransactionLimitNotifyDill.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    dwollaTransactionLimitNotifyDill.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    }
  );
  builder.addCase(
    dwollaTransactionLimitNotifyDill.rejected,
    (state, action: PayloadAction<any>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    }
  );
};

export const getSupplierTransactionsExtraReducer = (
  builder: ActionReducerMapBuilder<PaymentsInitialState>
) => {
  const reducerId = 'getSupplierTransactions';
  builder.addCase(getSupplierTransactions.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    getSupplierTransactions.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (action.payload && action.payload.success && action.payload?.data) {
        state.supplierTransactions = action.payload?.data?.transactions;
        const total =
          Number(action.payload?.data?.summary?.dwollaBalance?.value) +
          Number(action.payload?.data?.summary?.stripeBalance.availableAccountBalance) +
          Number(action.payload?.data?.summary?.stripeBalance.pendingAccountBalance) +
          Number(action.payload?.data?.summary?.fiservBalance.transactionsTotal);
        const amountAvailable =
          Number(action.payload?.data?.summary?.dwollaBalance?.value) +
          Number(action.payload?.data?.summary?.stripeBalance.availableAccountBalance) +
          Number(action.payload?.data?.summary?.fiservBalance.transactionsTotal);
        state.totalSupplierBalance = String(total);
        state.amountToWithraw = String(amountAvailable);
        state.totalAmountForPendingTransactions = Number(
          action.payload?.data?.summary?.totalAmountForPendingTransactions || 0
        );
      }
    }
  );
  builder.addCase(getSupplierTransactions.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};
export const getSupplierPosTransactionsExtraReducer = (
  builder: ActionReducerMapBuilder<PaymentsInitialState>
) => {
  const reducerId = 'getSupplierPosTransactions';
  builder.addCase(getSupplierPosTransactions.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    getSupplierPosTransactions.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (action.payload && action.payload.success && action.payload?.data) {
        state.supplierPosTransactions = action.payload?.data?.transactions;
      }
    }
  );
  builder.addCase(getSupplierPosTransactions.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};
export const getSupplierPaymentsFilesExtraReducer = (
  builder: ActionReducerMapBuilder<PaymentsInitialState>
) => {
  const reducerId = 'getSupplierPaymentsFiles';
  builder.addCase(getSupplierPaymentsFiles.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    getSupplierPaymentsFiles.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    }
  );
  builder.addCase(getSupplierPaymentsFiles.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};
export const getSupplierPaymentsReportJsonExtraReducer = (
  builder: ActionReducerMapBuilder<PaymentsInitialState>
) => {
  const reducerId = 'getSupplierPaymentsReportJson';
  builder.addCase(getSupplierPaymentsReportJson.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    getSupplierPaymentsReportJson.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (action.payload?.data) {
        state.paymentsReportData = action.payload.data;
      }
    }
  );
  builder.addCase(getSupplierPaymentsReportJson.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};
export const getWeekPaymentTransactionsLimitationsForMainBuyerExtraReducer = (
  builder: ActionReducerMapBuilder<PaymentsInitialState>
) => {
  const reducerId = 'getWeekPaymentTransactionsLimitationsForMainBuyer';
  builder.addCase(getWeekPaymentTransactionsLimitationsForMainBuyer.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    getWeekPaymentTransactionsLimitationsForMainBuyer.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (action.payload && action.payload.success && action.payload?.data) {
        const { totalAmountTransacted, weekLimit } = action.payload?.data;
        state.weekLimitations = { totalAmountTransacted, weekLimit };
      }
    }
  );
  builder.addCase(
    getWeekPaymentTransactionsLimitationsForMainBuyer.rejected,
    (state, action: PayloadAction<any>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    }
  );
};
export const getStripeSupplierAccountExtraReducer = (
  builder: ActionReducerMapBuilder<PaymentsInitialState>
) => {
  const reducerId = 'getStripeSupplierAccount';
  builder.addCase(getStripeSupplierAccount.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    getStripeSupplierAccount.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (action.payload && action.payload.success && action.payload?.data) {
        state.stripeCustomer = action.payload?.data;
      }
    }
  );
  builder.addCase(getStripeSupplierAccount.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};
export const getStripeConfigExtraReducer = (
  builder: ActionReducerMapBuilder<PaymentsInitialState>
) => {
  const reducerId = 'getStripeConfig';
  builder.addCase(getStripeConfig.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    getStripeConfig.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (action.payload && action.payload.success && action.payload?.data) {
        state.publishableKey = action.payload?.data.publishableKey;
      }
    }
  );
  builder.addCase(getStripeConfig.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};
export const getSupplierRegistrationStatusExtraReducer = (
  builder: ActionReducerMapBuilder<PaymentsInitialState>
) => {
  const reducerId = 'getSupplierRegistrationStatus';
  builder.addCase(getSupplierRegistrationStatus.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    getSupplierRegistrationStatus.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (action.payload && action.payload.success && action.payload?.data) {
        state.supplierRegistrationStatus = action.payload?.data;
      }
    }
  );
  builder.addCase(getSupplierRegistrationStatus.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const deletePaymentMethodByMainBuyerExtraReducer = (
  builder: ActionReducerMapBuilder<PaymentsInitialState>
) => {
  const reducerId = 'deletePaymentMethodByMainBuyer';
  builder.addCase(deletePaymentMethodByMainBuyer.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    deletePaymentMethodByMainBuyer.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    }
  );
  builder.addCase(deletePaymentMethodByMainBuyer.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const sendInvoicePaymentReminderEmailExtraReducer = (
  builder: ActionReducerMapBuilder<PaymentsInitialState>
) => {
  const reducerId = 'sendInvoicePaymentReminderEmail';
  builder.addCase(sendInvoicePaymentReminderEmail.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    sendInvoicePaymentReminderEmail.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    }
  );
  builder.addCase(sendInvoicePaymentReminderEmail.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const sendBulkInvoicePaymentReminderEmailsExtraReducer = (
  builder: ActionReducerMapBuilder<PaymentsInitialState>
) => {
  const reducerId = 'sendBulkInvoicePaymentReminderEmails';
  builder.addCase(sendBulkInvoicePaymentReminderEmails.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    sendBulkInvoicePaymentReminderEmails.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    }
  );
  builder.addCase(
    sendBulkInvoicePaymentReminderEmails.rejected,
    (state, action: PayloadAction<any>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    }
  );
};

export const getSupplierCustomerPaymentMethodsExtraReducer = (
  builder: ActionReducerMapBuilder<PaymentsInitialState>
) => {
  const reducerId = 'getSupplierCustomerPaymentMethods';
  builder.addCase(getSupplierCustomerPaymentMethods.pending, (state, action) => {
    if (!action.meta.arg?.isHideLoadingIndicator) {
      state.loadingList = [...new Set([...state.loadingList, reducerId])];
    }
    state.supplierCustomerPaymentMethods = [];
  });
  builder.addCase(
    getSupplierCustomerPaymentMethods.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (action.payload && action.payload.success && action.payload?.data) {
        state.supplierCustomerPaymentMethods = action.payload?.data;
      }
    }
  );
  builder.addCase(
    getSupplierCustomerPaymentMethods.rejected,
    (state, action: PayloadAction<any>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    }
  );
};

export const payFixedAmountExtraReducer = (
  builder: ActionReducerMapBuilder<PaymentsInitialState>
) => {
  const reducerId = 'payFixedAmount';
  builder.addCase(payFixedAmount.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
    state.paymentError = null;
  });
  builder.addCase(
    payFixedAmount.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (action.payload && action.payload.success && action.payload?.data) {
        // state.transactions = action.payload?.data;
      }
    }
  );
  builder.addCase(payFixedAmount.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    state.paymentError = action.payload;
  });
};

export const getPlaidBankStatementsPDFExtraReducer = (
  builder: ActionReducerMapBuilder<PaymentsInitialState>
) => {
  const reducerId = 'getPlaidBankStatementsPDF';
  builder.addCase(getPlaidBankStatementsPDF.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    getPlaidBankStatementsPDF.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    }
  );
  builder.addCase(getPlaidBankStatementsPDF.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const getPlaidBankStatementsExtraReducer = (
  builder: ActionReducerMapBuilder<PaymentsInitialState>
) => {
  const reducerId = 'getPlaidBankStatements';
  builder.addCase(getPlaidBankStatements.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
    state.transactionPlaidStatement = [];
  });
  builder.addCase(
    getPlaidBankStatements.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (action.payload && action.payload.success && action.payload?.data) {
        state.transactionPlaidStatement = action.payload?.data;
      }
    }
  );
  builder.addCase(getPlaidBankStatements.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    state.transactionPlaidStatement = [];
  });
};

export const getScheduledPaymentsExtraReducer = (
  builder: ActionReducerMapBuilder<PaymentsInitialState>
) => {
  const reducerId = 'getScheduledPayments';
  builder.addCase(getScheduledPayments.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    getScheduledPayments.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (action.payload && action.payload.success && action.payload?.data) {
        state.scheduledPayments = action.payload?.data;
      }
    }
  );
  builder.addCase(getScheduledPayments.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const createScheduledPaymentExtraReducer = (
  builder: ActionReducerMapBuilder<PaymentsInitialState>
) => {
  const reducerId = 'createScheduledPayment';
  builder.addCase(createScheduledPayment.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
    state.paymentError = null;
  });
  builder.addCase(createScheduledPayment.fulfilled, (state, action) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
  builder.addCase(createScheduledPayment.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    state.paymentError = action.payload ?? null;
  });
};

export const updateScheduledPaymentDateExtraReducer = (
  builder: ActionReducerMapBuilder<PaymentsInitialState>
) => {
  const reducerId = 'updateScheduledPaymentDate';
  builder.addCase(updateScheduledPaymentDate.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(updateScheduledPaymentDate.fulfilled, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    const updated = action.payload?.data;
    if (updated?.id) {
      state.scheduledPayments = state.scheduledPayments.map((scheduledPayment) =>
        scheduledPayment.id === updated.id ? { ...scheduledPayment, ...updated } : scheduledPayment
      );
    }
  });
  builder.addCase(updateScheduledPaymentDate.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const cancelScheduledPaymentExtraReducer = (
  builder: ActionReducerMapBuilder<PaymentsInitialState>
) => {
  const reducerId = 'cancelScheduledPayment';
  builder.addCase(cancelScheduledPayment.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(cancelScheduledPayment.fulfilled, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    const cancelledId = action.payload?.scheduledPaymentId;
    if (cancelledId) {
      // Dropped rather than status-flipped: the list only ever shows open scheduled payments.
      state.scheduledPayments = state.scheduledPayments.filter(
        (scheduledPayment) => scheduledPayment.id !== cancelledId
      );
    }
  });
  builder.addCase(cancelScheduledPayment.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const getSupplierScheduledPaymentsExtraReducer = (
  builder: ActionReducerMapBuilder<PaymentsInitialState>
) => {
  const reducerId = 'getSupplierScheduledPayments';
  builder.addCase(getSupplierScheduledPayments.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    getSupplierScheduledPayments.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (action.payload && action.payload.success && action.payload?.data) {
        state.supplierScheduledPayments = action.payload?.data;
      }
    }
  );
  builder.addCase(getSupplierScheduledPayments.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};
